import React from 'react'; 
import { NavLink } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <table className="footer-table">
          <tbody>
            {/* Quick Links Section - White Background */}
            <div className="footer-container1">
              {/* Quick Links - Left Side */}
              <div className="footer-section quick-links">
                <h3>Quick Links</h3>
                <ul>
                  <li>
                    <NavLink to="/" className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}>
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Administration" className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}>
                    Administration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Gallery" className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}>
                    Gallery
                    </NavLink>
                  </li>
              
                </ul> <br/>
                
                {/* Subscribe to Newsletter Form */}
                {/* <h3>Subscribe to our Newsletter</h3> */}
                <form className="newsletter-form">
                  <input type="email" placeholder="Enter your email address" required />
                  <button type="submit">Subscribe</button>
                </form>
                <p>Subscribe to our Newsletter</p>
              </div>

              {/* Contact Information - Right Side */}
              <div className="footer-section contact-info">
                <h3>Contact Information</h3>
                <p>
                  <strong>Director:</strong>{' '}
                  <a href="tel:+919928019295" className="footer-link">
                    Mrs. Ritu Chauhan (+91 99280 19295 )
                  </a>{' '}/{' '}<br />
                  <strong>Project Coordinator:</strong>{' '}
                  <a href="tel:+919782602097" className="footer-link">
                    Vikram Singh Rathore ( +91 97826 02097 )
                  </a>
                </p><br />
                <p>
                  <strong>Email:</strong>
                  <a href="mailto:rdtcsingawal@gmail.com" className="footer-link">
                  rdtcsingawal@gmail.com</a>{' '}
                  <a href="mailto:rajasthanroadsafety@gmail.com" className="footer-link">
                    rajasthanroadsafety@gmail.com
                  </a>
                </p><br />
                <p>
                  <strong>Address:</strong>{' '}
                  <a
                    href="https://www.google.com/maps?q=N.H.%2048%20Singawal%20Chauraha,%20Tahsil%20%E2%80%93%20Binay,%20District%20%E2%80%93%20Kekri,%20Singawal%20%E2%80%93%20Ajmer,%20Rajasthan,%20Pincode%20%E2%80%93%20305624"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    N.H. 48 Singawal Chauraha, Tahsil – Binay, District – Ajmer, Singawal – Rajasthan, Pincode – 305624
                  </a>
                </p>
              </div>


            </div>
            {/* Footer Bottom Section - Yellow Background */}
            <tr className="footer-row yellow-bg">
              <td className="footer-left">Designed by Aishwarya Joshi</td>
              <td>&copy; 2024 RDTC Singawal Driving Center. All Rights Reserved.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </footer>
  );
};

export default Footer;
